import _ from 'lodash';

import { getColorByUserId } from 'constants/presence';
import { getPersonInitials } from 'utils/loanApplication';

import { getMemberId, getMemberNickname } from '../TeamChat.utils';

const splitNickname = nickname => {
  const words = _.isString(nickname) ? nickname.trim().split(/\s+/).filter(Boolean) : [];

  switch (words.length) {
    case 0:
      return { firstName: '', lastName: '' };
    case 1:
      return { firstName: words[0], lastName: '' };
    default:
      return { firstName: words[0], lastName: words[words.length - 1] };
  }
};

export const getMemberInitials = member => {
  const nickname = getMemberNickname(member);
  const { firstName, lastName } = splitNickname(nickname);
  const initials = getPersonInitials({ firstName, lastName });

  return initials ? initials.toUpperCase() : '';
};

export const getMemberColor = member => getColorByUserId(getMemberId(member));
